import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import { useSelector } from "react-redux";
import Snackbar from "../../../Snackbar";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    LampCeilingIcon,
    KanbanIcon,
    Joystick,
    PlugZap,
    XCircle,
    Quote,
    OctagonAlert,
    AirplayIcon} from 'lucide-react';
import LoadingButton from "../../Loading/LoadingButton";

const ShowAdditionalInfoCards = ({setActiveCardOverview,baseUrl})=>{
  const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

 const [loader , setLoader] =useState({status:false});
 const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
 const [editType, setEditType] = useState(courseData?.ID?"videoLinks":"");
const videoLinks =courseData?.videoLinks?JSON.parse(courseData?.videoLinks):[];

 const [animate, setAnimate] = useState(false);

 let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
  courseData?.type=='batch'?"Batch":
  courseData?.type=="testSeries"?"Test":
  courseData?.type=="homeTutor"?"":
  courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Product":"":"Course";

 useEffect(() => {
    // console.log(itemArr)
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);
useEffect(()=>{
  setActiveCardOverview(true);
  
  // setCourseTitleData();
},[])



    
    
    
    
const handleBack=(e)=>{
  
    setLoader({status:true});
    
    history.goBack();
    }
    
    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"style={{}}><div  className="" style={{background:"#fff",padding:"5px",paddingTop:"20px",borderRadius:"25px"}}>

<h1 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(-50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',
      }}> Phase 3:  <span className="coloredTextV1" > Additional Info </span> </h1>
<div className="gridForWhatsNextAfterYT" style={{background:"#f9f9f9",borderRadius:"25px",padding:"10px",alignContent:"center",textAlign:"center",
        
    }}>

    

 <div align="left" className="itemCourseOuter" style={{ transform: animate ? 'translateY(0)' : 'translateY(100px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',marginBottom:"40px",height:"150px" ,background:"rgba(86, 82, 131,.6)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#ffffff",width:"50px",height:"50px",borderRadius:"50%",
      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><KanbanIcon  size={32}  color="rgba(86, 82, 131,.6)"/></div> 
<div className="progress-bar-card-title" style={{color:"#ffffff"}}>
  Completed : {courseData?.whatWillILearn?JSON.parse(courseData?.whatWillILearn)?.length?"100%":"0%":"0%"}
   ({courseData?.whatWillILearn?JSON.parse(courseData?.whatWillILearn)?.length?1:0:0}/1)
<div className="progress-bar-card-outer" style={{width:"100%"}}>
  <div className="progress-bar-card-inner" style={{width:courseData?.whatWillILearn?JSON.parse(courseData?.whatWillILearn)?.length?"100%":"0%":"0%"}}></div>
  </div>
  </div>
 
</div><div  className="set-expiry-card-bottom"style={{justifyContent:"space-around",color:"#ffffff"}} >
<h2> What Will I Learn</h2> 
 <button 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave}
  onClick={()=>{ 
    history.push(`/apps/${AppToken}/create/what-will-i-learn`)
     

   }}  
 className="selectThumbOuterRightButtonRemove"   type="submit"
 id="signupBtn"> <span className="" >Set It</span> </button>
  </div>
<div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div></div>
 </div>   </div>

<div align="left" className="itemCourseOuter" style={{ transform: animate ? 'translateY(0)' : 'translateY(100px)',
       opacity: animate ? 1 : 0,
       transition: 'transform 1.5s ease, opacity 1.5s ease',marginBottom:"40px",height:"150px" ,background:"rgba(86, 82, 131,.6)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#ffffff",width:"50px",height:"50px",borderRadius:"50%",
     float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><LampCeilingIcon  size={32}  color="rgba(86, 82, 131,.6)"/></div> 
<div className="progress-bar-card-title" style={{color:"#ffffff"}}>
 Completed : {courseData?.targetAudience?JSON.parse(courseData?.targetAudience)?.length?"100%":"0%":"0%"}
  ({courseData?.targetAudience?JSON.parse(courseData?.targetAudience)?.length?1:0:0}/1)
<div className="progress-bar-card-outer" style={{width:"100%"}}>
 <div className="progress-bar-card-inner" style={{width:courseData?.targetAudience?JSON.parse(courseData?.targetAudience)?.length?"100%":"0%":"0%"}}></div>
 </div>
 </div>

</div><div  className="set-expiry-card-bottom"style={{justifyContent:"space-around",color:"#ffffff"}} >
<h2> Target Audience</h2> 
<button 
onMouseEnter={
 ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave}
 onClick={()=>{ 
   history.push(`/apps/${AppToken}/create/target-audience`)
    

  }}  
className="selectThumbOuterRightButtonRemove"   type="submit"
id="signupBtn"> <span className="" >Set It</span> </button>
 </div>
<div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div></div>
</div>   </div>

<div align="left" className="itemCourseOuter" style={{ transform: animate ? 'translateY(0)' : 'translateY(100px)',
       opacity: animate ? 1 : 0,
       transition: 'transform 2s ease, opacity 2s ease',marginBottom:"40px",height:"150px" ,background:"rgba(86, 82, 131,.6)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#ffffff",width:"50px",height:"50px",borderRadius:"50%",
     float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><Joystick  size={32}  color="rgba(86, 82, 131,.6)"/></div> 
<div className="progress-bar-card-title" style={{color:"#ffffff"}}>
 Completed : {courseData?.preRequisite?JSON.parse(courseData?.preRequisite)?.length?"100%":"0%":"0%"}
  ({courseData?.preRequisite?JSON.parse(courseData?.preRequisite)?.length?1:0:0}/1)
<div className="progress-bar-card-outer" style={{width:"100%"}}>
 <div className="progress-bar-card-inner" style={{width:courseData?.preRequisite?JSON.parse(courseData?.preRequisite)?.length?"100%":"0%":"0%"}}></div>
 </div>
 </div>

</div>
<div  className="set-expiry-card-bottom"style={{justifyContent:"space-around",color:"#ffffff"}} >
<h2> Pre-requisite</h2> 
<button 
onMouseEnter={
 ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave}
 onClick={()=>{ 
   history.push(`/apps/${AppToken}/create/prerequisite`)
    

  }}  
className="selectThumbOuterRightButtonRemove"   type="submit"
id="signupBtn"> <span className="" >Set It</span> </button>
 </div>
<div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div></div>
</div>   </div>
    


<div align="left" className="itemCourseOuter" style={{ transform: animate ? 'translateY(0)' : 'translateY(100px)',
       opacity: animate ? 1 : 0,
       transition: 'transform 2.5s ease, opacity 2.5s ease',marginBottom:"40px",height:"150px" ,background:"rgba(86, 82, 131,.6)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#ffffff",width:"50px",height:"50px",borderRadius:"50%",
     float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><PlugZap  size={32}  color="rgba(86, 82, 131,.6)"/></div> 
<div className="progress-bar-card-title" style={{color:"#ffffff"}}>
 Completed : {courseData?.highlights?JSON.parse(courseData?.highlights)?.length?"100%":"0%":"0%"}
  ({courseData?.highlights?JSON.parse(courseData?.highlights)?.length?1:0:0}/1)
<div className="progress-bar-card-outer" style={{width:"100%"}}>
 <div className="progress-bar-card-inner" style={{width:courseData?.highlights?JSON.parse(courseData?.highlights)?.length?"100%":"0%":"0%"}}></div>
 </div>
 </div>

</div>
<div  className="set-expiry-card-bottom"style={{justifyContent:"space-around",color:"#ffffff"}} >
<h2> Highlights</h2> 
<button 
onMouseEnter={
 ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave}
 onClick={()=>{ 
   history.push(`/apps/${AppToken}/create/highlights`)
    

  }}  
className="selectThumbOuterRightButtonRemove"   type="submit"
id="signupBtn"> <span className="" >Set It</span> </button>
 </div>
<div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div></div>
</div>   </div>
    
<div align="left" className="itemCourseOuter" style={{ transform: animate ? 'translateY(0)' : 'translateY(100px)',
       opacity: animate ? 1 : 0,
       transition: 'transform 3s ease, opacity 3s ease',marginBottom:"40px",height:"150px" ,background:"rgba(86, 82, 131,.6)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#ffffff",width:"50px",height:"50px",borderRadius:"50%",
     float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><AirplayIcon  size={32}  color="rgba(86, 82, 131,.6)"/></div> 
<div className="progress-bar-card-title" style={{color:"#ffffff"}}>
 Completed : {courseData?.skills?JSON.parse(courseData?.skills)?.length?"100%":"0%":"0%"}
  ({courseData?.skills?JSON.parse(courseData?.skills)?.length?1:0:0}/1)
<div className="progress-bar-card-outer" style={{width:"100%"}}>
 <div className="progress-bar-card-inner" style={{width:courseData?.skills?JSON.parse(courseData?.skills)?.length?"100%":"0%":"0%"}}></div>
 </div>
 </div>

</div>
<div  className="set-expiry-card-bottom"style={{justifyContent:"space-around",color:"#ffffff"}} >
<h2> Skills Taught</h2> 
<button 
onMouseEnter={
 ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave}
 onClick={()=>{ 
   history.push(`/apps/${AppToken}/create/skills`)
    

  }}  
className="selectThumbOuterRightButtonRemove"   type="submit"
id="signupBtn"> <span className="" >Set It</span> </button>
 </div>
<div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div></div>
</div>   </div>
    
<div align="left" className="itemCourseOuter" style={{ transform: animate ? 'translateY(0)' : 'translateY(100px)',
       opacity: animate ? 1 : 0,
       transition: 'transform 3.5s ease, opacity 3.5s ease',marginBottom:"40px",height:"150px" ,background:"rgba(86, 82, 131,.6)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#ffffff",width:"50px",height:"50px",borderRadius:"50%",
     float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><Quote  size={32}  color="rgba(86, 82, 131,.6)"/></div> 
<div className="progress-bar-card-title" style={{color:"#ffffff"}}>
 Completed : {courseData?.FAQs?JSON.parse(courseData?.FAQs)?.length?"100%":"0%":"0%"}
  ({courseData?.FAQs?JSON.parse(courseData?.FAQs)?.length?1:0:0}/1)
<div className="progress-bar-card-outer" style={{width:"100%"}}>
 <div className="progress-bar-card-inner" style={{width:courseData?.FAQs?JSON.parse(courseData?.FAQs)?.length?"100%":"0%":"0%"}}></div>
 </div>
 </div>

</div>
<div  className="set-expiry-card-bottom"style={{justifyContent:"space-around",color:"#ffffff"}} >
<h2> {TypeTitle} FAQs</h2> 
<button 
onMouseEnter={
 ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave}
 onClick={()=>{ 
   history.push(`/apps/${AppToken}/create/faqs`)
    

  }}  
className="selectThumbOuterRightButtonRemove"   type="submit"
id="signupBtn"> <span className="" >Set It</span> </button>
 </div>
<div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div></div>
</div>   </div>
    

<div style={{height:"70px"}}></div>
 </div>
 <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/labels`)}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/trial`)}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Go Next":"Go Next"} </button>
     
  </div>
  </div></div>
</>}
    </>

}

export default ShowAdditionalInfoCards;


